import React from "react";
import{ Link} from 'react-router-dom'
import "tachyons"
import thmnail1 from "../imgs/liftthumbnail.png"
import thmnail2 from "../imgs/dragthumbnail.png"
import thmnail3 from "../imgs/thrustthumbmail.png"
import "./GetStarted.css";

const GetStarted=()=>{
	return(
			<div className="cards">
			<Link to="/liftinfo">
				<div className="card1 grow">
					<img src={thmnail1} alt="thbmnail1" className="thbmnail1"/>
					<h1>LIFT</h1>
					<h3>Lift is a force that holds an aircraft in air...</h3>
					<button className="button1">More</button>
				</div>
				</Link>

				<Link to="/draginfo">

				<div className="card2 grow">
					<img src={thmnail2} alt="thbmnail1" className="thbmnail2"/>
					<h1>DRAG</h1>
					<h3>The force which acts opposite to the aircraft moving in the air...</h3>
					<button className="button1">More</button>
				</div>
				</Link>

				<Link to="/thrustinfo">

				<div className="card3 grow">
					<img src={thmnail3} alt="thbmnail3" className="thbmnail3"/>
					<h1>THRUST</h1>
					<h3>Thrust is force which moves an aircraft through the air...</h3>
					<button className="button1">More</button>
				</div>
				</Link>
			</div>
		);

}
export default GetStarted;